import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Button } from "../ui/button";
import { Loader2, FileSpreadsheet, Download, Sparkles } from "lucide-react";
import { ShoppingCart, UtensilsCrossed, Package, Receipt } from "lucide-react";

const TYPE_META = {
  sales: { label: "Ventas", icon: null, color: "text-green-600", bg: "bg-green-50 dark:bg-green-950/20" },
  menu: { label: "Menú", icon: null, color: "text-blue-600", bg: "bg-blue-50 dark:bg-blue-950/20" },
  inventory: { label: "Inventario", icon: null, color: "text-amber-700", bg: "bg-amber-50 dark:bg-amber-950/20" },
  expenses: { label: "Gastos", icon: null, color: "text-rose-700", bg: "bg-rose-50 dark:bg-rose-950/20" },
};

const descriptions = {
  sales: "Ventas y tickets de caja desde cualquier TPV",
  menu: "Carta de platos y precios desde tu TPV",
  inventory: "Stock e ingredientes desde tu sistema de gestión",
  expenses: "Facturas y gastos históricos (proveedores, utilities, alquiler…)",
};

const sampleCols = {
  sales: "fecha · producto · cantidad · precio · total · pago",
  menu: "nombre · descripción · precio · categoría",
  inventory: "nombre · stock · unidad · coste/ud · stock mínimo",
  expenses: "fecha · proveedor · NIF · total · IVA · categoría",
};

const TYPE_ICONS = {
  sales: ShoppingCart,
  menu: UtensilsCrossed,
  inventory: Package,
  expenses: Receipt,
};

export function CSVImportCard({ type, fileRef, analyzing, onFileSelect, onDownloadSample }) {
  const meta = TYPE_META[type];
  const Icon = TYPE_ICONS[type];

  return (
    <Card data-testid={`csv-import-card-${type}`}>
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <Icon className={`w-5 h-5 ${meta.color}`} />
          Importar {meta.label}
        </CardTitle>
        <CardDescription className="text-xs">{descriptions[type]}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div
          className="border-2 border-dashed rounded-xl p-6 text-center cursor-pointer hover:border-primary/60 hover:bg-primary/5 transition-all"
          onClick={() => !analyzing && fileRef.current?.click()}
          data-testid={`csv-drop-area-${type}`}
        >
          {analyzing ? (
            <>
              <Sparkles className="w-8 h-8 mx-auto mb-2 text-primary animate-pulse" />
              <p className="text-sm font-medium text-primary">Analizando con IA...</p>
              <p className="text-xs text-muted-foreground mt-1">Detectando formato del CSV</p>
            </>
          ) : (
            <>
              <FileSpreadsheet className="w-8 h-8 mx-auto mb-2 text-muted-foreground" />
              <p className="text-sm font-medium">Haz clic para subir CSV o Excel</p>
              <p className="text-xs text-muted-foreground mt-1 font-mono">{sampleCols[type]}</p>
              <p className="text-xs text-muted-foreground mt-0.5">.csv · .xlsx · .xls</p>
            </>
          )}
        </div>
        <input
          ref={fileRef}
          type="file"
          accept=".csv,.tsv,.txt,.xlsx,.xls"
          className="hidden"
          data-testid={`csv-file-input-${type}`}
          onChange={(e) => { const f = e.target.files?.[0]; if (f) onFileSelect(f); }}
        />
        <Button variant="ghost" size="sm" className="w-full text-xs gap-1" onClick={onDownloadSample}>
          <Download className="w-3.5 h-3.5" />
          Descargar CSV de ejemplo
        </Button>
      </CardContent>
    </Card>
  );
}
